package com.artvending.warden.screens.history

import androidx.compose.runtime.*
import androidx.compose.runtime.remember
import com.artvending.warden.Alignment
import com.artvending.warden.Box
import com.artvending.warden.Card
import com.artvending.warden.Card_
import com.artvending.warden.Column
import com.artvending.warden.Column_
import com.artvending.warden.Grid
import com.artvending.warden.HistoryUnit
import com.artvending.warden.HistoryUnitMode
import com.artvending.warden.MdIcon
import com.artvending.warden.MdIconButton
import com.artvending.warden.MdLinearProgress
import com.artvending.warden.MdPrimaryTab
import com.artvending.warden.MdTabs
import com.artvending.warden.Overflow
import com.artvending.warden.Panel
import com.artvending.warden.Rectangle
import com.artvending.warden.Row
import com.artvending.warden.Row_
import com.artvending.warden.Space
import com.artvending.warden.StackScope
import com.artvending.warden.TextAlignment
import com.artvending.warden.TextButton
import com.artvending.warden.Text_
import com.artvending.warden.getDayOfWeekStr
import com.artvending.warden.getMonthFullNumber
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.minutesToTimeString
import com.artvending.warden.myOnClick
import com.artvending.warden.toColor
import com.artvending.warden.toMyString
import com.artvending.warden.today
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.attributes.Draggable
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.div
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.gridColumn
import org.jetbrains.compose.web.css.gridColumnEnd
import org.jetbrains.compose.web.css.gridColumnStart
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.transform
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Tr
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event


inline val org.w3c.dom.events.EventTarget.activeTabIndex_: Int?
	get() = this.asDynamic().activeTabIndex as? Int


@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun StackScope.HistoryScreen_(model: HistoryScreenModel) {
	@Composable
	fun Month() {
		Row(space = settings.smallSpace, weight = 1, paddingHorizontal = settings.space) {
			Text_("${model.currentMonthStr} ${model.currentMonth / 12}", classes = settings.headlineFontClass, weight = 1, marginLeft = settings.space)
			MdIconButton({ myOnClick { model.currentMonth--; model.loadCurrentMonth(model.currentMonth) } }) {
				MdIcon {
					Img("left.svg", "<") { draggable(Draggable.False); }
				}
			}
			MdIconButton({ myOnClick { model.currentMonth++; model.loadCurrentMonth(model.currentMonth) } }) {
				MdIcon {
					Img("right.svg", ">") { draggable(Draggable.False); }
				}
			}
		}
	}
	
	
	@Composable
	fun StackScope.DayView(units: List<HistoryUnit>, showDay: Boolean, stretch: Boolean) {
		if (units.isEmpty())
			Text_(language.NO_DATA, alignment = if (stretch) Alignment.stretch else Alignment.start, textAlignment = TextAlignment.center, color = settings.opacityLightGray)
		else {
			Grid(alignment = if (stretch) Alignment.stretch else Alignment.start) {
				for ((i, unit) in units.withIndex()) {
					val date = unit.date
					val preDate = if (i > 0) units[i - 1].date else null
					val sameDate = preDate == date
					val otherWeek = preDate != null && ((date.dayOfMonth - preDate.dayOfMonth) >= 7 || date.dayOfWeek.ordinal < preDate.dayOfWeek.ordinal)
					
					if (otherWeek)
						Rectangle(
							alignment = Alignment.stretch, marginVertical = settings.space, height = 1.px, backgroundColor = settings.opacityLightGray,
							columnIndex = 0, columnSpan = 6
						)
					
					if (i > 0 && !sameDate && !otherWeek)
						Rectangle(size = settings.smallSpace, columnIndex = 0, columnSpan = 6)
					
					if (showDay) {
						Text_(if (sameDate) "" else "${unit.date.getDayOfWeekStr()}.", columnIndex = 0)
						Text_(if (sameDate) "" else "${unit.date.dayOfMonth}:", columnIndex = 1)
					}
					
					Text_(
						"${if (unit.mode == HistoryUnitMode.FIXED_WORKING_TIME) if (date == today) unit.mode else language.IN_WORK2 else unit.mode}",
						color = unit.mode.color.toColor(), columnIndex = 2
					)
					Text_(
						minutesToTimeString(unit.fixedFrom, true), cornerRadius = 300.px, paddingVertical = settings.smallSpace / 4, columnIndex = 3,
						paddingHorizontal = settings.smallSpace, backgroundColor = if (unit.getLate(model.units) > 0) rgba(255, 0, 0, 0.15) else null,
						alignment = Alignment.center, marginHorizontal = if (stretch) null else settings.smallSpace
					)
					Text_("-", columnIndex = 4)
					Text_(
						minutesToTimeString(unit.fixedTo, true), cornerRadius = 300.px, paddingVertical = settings.smallSpace / 4, columnIndex = 5,
						paddingHorizontal = settings.smallSpace, backgroundColor = if (unit.getEarlyEnd(model.units) > 0) rgba(255, 0, 0, 0.15) else null,
						alignment = Alignment.center, marginHorizontal = if (stretch) null else settings.smallSpace
					)
				}
			}
		}
	}
	
	
	@Composable
	fun ListView() {
		Card {
			if (model.progress)
				Div({ style { alignSelf(AlignSelf.Stretch); padding(settings.smallSpace / 4); textAlign("center"); color(settings.opacityGray) } }) {
					Text(language.LOADING_DATA)
				}
			else
				DayView(model.units, true, true)
		}
	}
	
	var tabsRef: HTMLElement? by remember { mutableStateOf<HTMLElement?>(null) }
	
	
	@Composable
	fun Calendar() {
		val today = today
		val firstDayOfMonth = LocalDate(model.currentMonth / 12, (model.currentMonth % 12) + 1, 1)
		val firstDayOfMonthDayOfWeek = firstDayOfMonth.dayOfWeek.ordinal
		var date = firstDayOfMonth.plus(-firstDayOfMonthDayOfWeek, DateTimeUnit.DAY)
		
		Card_ {
			Grid(space = 2.px) {
				for (i in 0..6)
					Text_(
						getDayOfWeekStr(i), padding = settings.smallSpace, textAlignment = TextAlignment.center,
						color = if (i == 5 || i == 6) settings.opacityGray else null, columnIndex = i
					)
				
				for (i in 0..5)
					for (j in 0..6) {
						if (date.getMonthFullNumber() == model.currentMonth) {
							val date = LocalDate(date.year, date.month, date.dayOfMonth)
							
							TextButton(
								{ model.selectDate(date) },
								{
									style {
										property("aspect-ratio", "1 / 1")
										width(100.percent)
										padding(settings.smallSpace, 0.px)
										minWidth(0.px)
										minHeight(0.px)
										if (date == today) fontWeight("bold")
										position(Position.Relative)
										gridColumnStart(j + 1)
										gridColumnEnd(j + 2)
									}
								}
							) {
								Box(alignment = Alignment.stretch, style = { position(Position.Absolute); top(0.px); right(0.px); bottom(0.px); left(0.px); }) {
									Column(space = 2.px, style = { position(Position.Absolute); top(0.px); right(0.px); bottom(0.px); left(0.px); }) {
										for (unit in model.units.filter { it.date == date })
											Rectangle(weight = 1, backgroundColor = unit.mode.color.toColor(), opacity = 0.15)
									}
									if (date == today)
										Rectangle(cornerRadius = 500.px, borderColor = Color.royalblue, alignment = Alignment.stretch)
									
									if (date == model.selectedDate)
										Rectangle(cornerRadius = 500.px, backgroundColor = Color.royalblue, alignment = Alignment.stretch)
									
									Text_(
										date.dayOfMonth.toString(), alignment = Alignment.center, fontWeight = 400,
										color = if (j == 5 || j == 6 || date.getMonthFullNumber() != model.currentMonth)
											settings.opacityGray
										else
											if (model.units.any { it.date == date && (it.getLate(model.units) > 0 || it.getEarlyEnd(model.units) > 0) })
												if (date == model.selectedDate) Color.pink else Color.red
											else
												if (date == model.selectedDate) Color.white else Color.black
									)
								}
							}
						}
						
						date = date.plus(1, DateTimeUnit.DAY)
					}
			}
		}
		
		
		if (model.selectedDate?.getMonthFullNumber() == model.currentMonth)
			Card_ {
				Text_(model.selectedDate?.toMyString() ?: "", classes = settings.titleFontClass)
				DayView(model.selectedDateUnits, false, false)
			}
	}
	
	
	Column(space = settings.space, marginTop = -settings.space) {
		Column(
			overflow = Overflow.hidden,
//			margin = -settings.space,
//			marginBottom = 0.px,
			space = settings.space + settings.smallSpace,
			backgroundColor = Color("#eeeeee"),
			style = { position(Position.Sticky); property("z-index", "1") }
		) {
			MdTabs({
				ref { tabsRef = it; onDispose { tabsRef = null } }
				style { margin(0.px, -settings.space) }
			}) {
				MdPrimaryTab(true) {
					Text(language.CALENDAR)
				}
				MdPrimaryTab {
					Text(language.LIST)
				}
			}
			Month()
		}
		MdLinearProgress {
			style {
				if (!model.progress) property("visibility", "hidden")
				margin(-settings.smallSpace, -settings.space)
			}
		}
		
		if (model.isCalendarMode)
			Calendar()
		else
			ListView()
	}

//	Column_({ style { gap(settings.space); marginTop(-settings.space) } }) {
//		Column_({
//			style {
//				position(Position.Sticky);
//				overflow("hidden")
//				top(-settings.space);
//				property("background-color", "#eeeeee");
//				property("z-index", "1")
//				margin(0.px, -settings.space)
//				gap(settings.space + settings.smallSpace)
//			}
//		}) {
//			MdTabs({
//				ref { tabsRef = it; onDispose { tabsRef = null } }
//				style { margin(0.px, -settings.space) }
//			}) {
//				MdPrimaryTab(true) {
//					Text(language.CALENDAR)
//				}
//				MdPrimaryTab {
//					Text(language.LIST)
//				}
//			}
//			Month()
//		}
//		MdLinearProgress {
//			style {
//				if (!model.progress) property("visibility", "hidden")
//				margin(-settings.smallSpace, -settings.space)
//			}
//		}
//
//		if (model.isCalendarMode)
//			Calendar()
//		else
//			ListView()
//
//	}
	
	LaunchedEffect(Unit) {
		tabsRef?.let { element ->
			element.addEventListener("change", { event: Event ->
				model.isCalendarMode = event.target?.activeTabIndex_ == 0
			})
		}
	}
}